import { useAuth } from "../../App"
import { useState, useEffect } from "react"
import { getAnnouncements } from "../../api/announcements"
import { AnnouncementProps } from "../../interfaces/announcement_types"
import { BaseDashboardLayout } from "./UI/BaseDashboardLayout"
import { ContactFormState } from "../../interfaces/contactUs_type"
import { GetContactUs } from "../../api/contactUs"
import { checkEmployeeHierarchy } from "../../api/utils"
/**
 * ### [Route for ('/main_menu')]
 * 
 * This component shows brief information about the user, their tasks and projects.
 * 
 * Based on the user's role, it will show / hide different buttons.
 * 
 * TODO:
 *  - Make sure to filter out projects and tasks that are passed due dates
 * - Make sure that projects and tasks are sorted by due date
 * - Still fix that grid layout
 */
export function MainMenu() {
    // Check what roles the user has
    // and show / hide buttons accordingly
    const [errorString, setErrorString] = useState<string>('')
    const [announcements, setAnnouncements] = useState<AnnouncementProps[]>([])
    const [contactUs, setContactUs] = useState<ContactFormState[]>([])

    // Get User's information
    const { user } = useAuth()

    useEffect(() => {
        if (!user) {
            setErrorString("User not authenticated")
            return
        }

        const get_announcements = async () => {
            try {
                const response = await getAnnouncements()
                setAnnouncements(response.data)
            } catch (error) {
                setErrorString("Error fetching announcements: " + error)
            }
        }

        const get_ContactUs = async () => {
            try {
                const response = await GetContactUs()
                if (response.status !== 200) {
                    setErrorString(response.message)
                } else {
                    setContactUs(response.data)
                }
            } catch (error) {
                setErrorString("Error fetching contact us: " + error)
            }
        }

        get_announcements()

        // Should be basically just admins and the CEO
        const user_hierarchy = checkEmployeeHierarchy(user.role)
        if (user_hierarchy === "ADMIN" || user.role === "CEO") {
            get_ContactUs()
        }
    }, [user])

    return (
        <>
            {errorString && <MainMenuError error={errorString} />}

            {user && <BaseDashboardLayout user={user} announcements={announcements} contactUs={contactUs}/>}
        </>
    )
}

function MainMenuError({ error } : { error: string }) {
    return (
        <>
            <div className='p-2 bg-red-400'>

                <h1 className="text-center">{error}</h1>

            </div>
        </>
    )
}
